export const stringCompareAlphabet = (stringLeft: string, stringRight: string): number => {
  return stringLeft.localeCompare(stringRight)
}
